import 'tailwindcss/tailwind.css';
import App from './containers/App';

export default App;
